import Vue from 'vue'
import dialogWrap from '@/components/dialogWrap'
import ColumnBox from '@/components/ColumnBox'
import ColumnBoxExpand from '@/components/ColumnBoxExpand'
import FromMatching from '@/components/FromMatching'
import UploadCommon from '@/components/UploadCommon'
import Export from '@/components/Export'
import OverLayout from '@/components/OverLayout'
import SvgIcon from '@/components/svg-icon/main.vue'
import QSTable from '@/components/CommonLayout/QSTable/QSTable.vue'
import QSSearch from '@/components/CommonLayout/QSSearch/QSSearch.vue'
import QSSearchGroupItem from '@/components/CommonLayout/QSSearch/QSSearchGroupItem.vue'
import QSLogin from '@/components/QSLogin/main.vue'
import ShowImgAndFile from '@/components/showImgAndFile/index.vue'
// 升级版dialogwrap
import DialogWrapUpgrade from '@/components/DialogWrapUpgrade'
import CropperImage from '@/components/CropperImage/index.vue'
import LoopCropperImage from '@/components/LoopCropperImage/index.vue'
import AreaLinkage from '@/components/AreaLinkage/index.vue'
import TableComponent from '@/components/TableComponent.vue'
import SearchBox from '@/components/SearchBox/index.vue'
import SelectTag from '@/components/SelectTag/index.vue'
import ShowTag from '@/components/ShowTag/index.vue'
import Pie from '@/components/Pie/index.vue'
import LineColumn from '@/components/LineColumn/index.vue'
import EnlargeImg from '@/components/EnlargeImg/index.vue'
import WxCodePopover from '@/components/WxCodePopover/index.vue'
import BaseForm from '@/components/BaseComponents/BaseForm'
import BaseTable from '@/components/BaseComponents/BaseTable'
import BaseListManagement from '@/components/BaseListManagement'
import SearchForm from '@/components/SearchForm'
import CombineButtons from '@/components/CombineButtons'// 组合按钮
import FormTextGenerator from '@/components/FormTextGenerator'
import FormTextBox from '@/components/FormTextBox'
import FormItem from '@/components/BaseComponents/FormItem'
import TextItem from '@/components/BaseComponents/TextItem'
import PdfPreview from '@/components/PdfPreview'
import CheckTextInput from '@/components/QSCheckTextInput'
import CarBrandSeriesModel from '@/components/CarBrandSeriesModel.vue'
import WaitForHandleCard from '@/pages/cars/list/components/WaitForHandleCard.vue'
import PublicImport from '@/components/PublicImport'
import PublicExport from '@/components/PublicExport'
import DeptTree from '@/components/DeptSelect/WithLabel.vue'
import QsDrawer from '@/components/QsDrawer/index.vue'
import DeptSelect from '@/components/DeptSelect/index.vue'
import TextOverTooltip from '@/components/TextOverTooltip'
import Card from '@/components/Card'
import CarSelect from '@/components/CarSelect'

const components = [
  // VClamp,
  dialogWrap,
  ColumnBox,
  ColumnBoxExpand,
  FromMatching,
  UploadCommon,
  Export,
  OverLayout,
  SvgIcon,
  QSTable,
  QSSearch,
  QSSearchGroupItem,
  QSLogin,
  DialogWrapUpgrade,
  CropperImage,
  LoopCropperImage,
  AreaLinkage,
  TableComponent,
  SearchBox,
  SelectTag,
  ShowTag,
  Pie,
  LineColumn,
  EnlargeImg,
  WxCodePopover,
  BaseForm,
  BaseTable,
  BaseListManagement,
  SearchForm,
  FormItem,
  TextItem,
  FormTextBox,
  FormTextGenerator,
  CombineButtons,
  PdfPreview,
  CheckTextInput,
  CarBrandSeriesModel,
  WaitForHandleCard,
  PublicImport,
  PublicExport,
  DeptTree,
  QsDrawer,
  DeptSelect,
  TextOverTooltip,
  ShowImgAndFile,
  Card,
  CarSelect,
]
components.forEach((comp) => {
  const name = (comp.name.slice(0, 1).toUpperCase()) + comp.name.slice(1)
  Vue.component(name, comp)
})
